import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, message } from 'antd';
import { authApi } from '../../../../apis';

/**
 * 패스워드 변경 페이지
 * @author
 * */
const ConfiremPassword = (props) => {
  // const navigate = useNavigate();
  const { id: email } = useParams();
  const [messageApi, contextHolder] = message.useMessage();

  const sendPassword = async () => {
    const tmpEmail = String(email.value || '').trim();
    if (tmpEmail.length) {
      const response = await authApi.post('/admin/reset', {
        email: tmpEmail.trim(),
      });
      // console.log('--->', response.data);
      if (response) {
        // window.location.replace('/password/confirm');
        messageApi.info('메일을 전송하는데 성공하였습니다.');
        return;
      }
    }

    messageApi.info('메일을 전송하는데 실패하였습니다.');
  };

  const styles = {
    input: { height: 34, width: 353, marginTop: 37, marginLeft: 16, border: 0 },
    button: {
      height: 34,
      width: 353,
      marginTop: 70,
      marginLeft: 16,
      background: '#7367F0',
    },
    link: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      height: 34,
      width: 353,
      marginTop: 16,
      marginLeft: 16,
      // font
      fontWeight: 400,
      fontSize: '1.5rem',
      lineHeight: '2.2rem',
      color: '#7367F0',
    },
  };
  return (
    <div className="container">
      {contextHolder}
      <div className="topArea">
        <div className="topBox" style={{ marginTop: '1rem' }} />
        <div className="topBorderBox" style={{ marginLeft: '-5rem' }} />
      </div>
      <div style={{ height: '32rem' }} />
      <div className="bottomArea">
        <div className="bottomBorderBox" style={{ marginRight: '8rem' }}>
          <div className="bottomBox" />
        </div>
      </div>
      <div
        className="centerArea"
        style={{
          flexDirection: 'column',
          marginTop: '-65rem',
          marginLeft: '-8rem',
          backgroundImage: `url(${require('../../../../assets/images/bkg_pwd_confirm.png')})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          paddingTop: '23rem',
          paddingLeft: '3.2rem',
        }}
      >
        <Button
          type="primary"
          style={{
            ...styles.button,
          }}
          onClick={(e) => {
            // console.log('password');
            window.location.replace('/');
          }}
        >{`건너뛰고 로그인 페이지로 이동`}</Button>

        <div
          style={{
            ...styles.link,
          }}
        >
          {`이메일은 받지 못하셨나요?`}
          <Button
            type="link"
            onClick={(e) => {
              sendPassword();
            }}
          >
            {`다시보내기`}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfiremPassword;
